const mediaItems = [
  {
    title: '4K超清视觉大片：绝美自然风光',
    duration: '12:38',
    views: '156万',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20with%20golden%20sunset%20over%20mountains%20and%20lakes%2C%20warm%20amber%20and%20orange%20sky%2C%20cinematic%20drone%20photography%2C%20epic%20natural%20scenery%2C%20professional%20nature%20documentary%20aesthetic%2C%20rich%20earthy%20color%20palette&width=600&height=340&seq=media-nature-01&orientation=landscape',
  },
  {
    title: '城市夜光：延时摄影精选',
    duration: '08:15',
    views: '98万',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20city%20nightscape%20with%20warm%20golden%20city%20lights%20reflecting%20on%20river%2C%20modern%20skyscrapers%20silhouette%2C%20dramatic%20twilight%20sky%2C%20cinematic%20urban%20photography%2C%20rich%20warm%20neon%20tones%2C%20professional%20time-lapse%20aesthetic&width=600&height=340&seq=media-city-02&orientation=landscape',
  },
  {
    title: '经典武打动作场面合集',
    duration: '15:42',
    views: '203万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20action%20scene%20with%20warm%20golden%20lighting%2C%20dynamic%20movement%20silhouette%20against%20sunset%20backdrop%2C%20professional%20film%20lighting%2C%20epic%20scale%2C%20warm%20amber%20and%20crimson%20color%20grading&width=600&height=340&seq=media-action-03&orientation=landscape',
  },
  {
    title: '美食纪录：全球街头小吃',
    duration: '20:05',
    views: '132万',
    image: 'https://readdy.ai/api/search-image?query=Warm%20atmospheric%20street%20food%20market%20at%20dusk%20with%20steam%20rising%20from%20food%20stalls%2C%20golden%20ambient%20lighting%2C%20busy%20night%20market%20scene%2C%20rich%20warm%20tones%2C%20documentary%20photography%20style%2C%20inviting%20atmosphere&width=600&height=340&seq=media-food-04&orientation=landscape',
  },
  {
    title: '动画短片大赏：年度精选',
    duration: '10:30',
    views: '178万',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20animation%20studio%20workspace%20with%20warm%20ambient%20lighting%2C%20sketch%20drawings%20on%20wooden%20desk%2C%20color%20palette%20with%20warm%20tones%2C%20creative%20atmosphere%2C%20soft%20golden%20backlight%2C%20cinematic%20composition&width=600&height=340&seq=media-anime-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
            精彩推荐
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            热门视频展示
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选最受欢迎的91免费视频网站在线观看内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="rounded-xl overflow-hidden border border-background-200/60 bg-background-100 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="relative w-full h-44 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="flex items-center gap-1 px-2 py-1 rounded-md bg-background-950/70 text-background-50 text-xs font-label font-medium whitespace-nowrap">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-play-fill text-[10px]"></i>
                    </span>
                    {item.duration}
                  </span>
                  <span className="text-xs text-background-100 whitespace-nowrap">{item.views} 次播放</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-sm text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}